import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { ReceivableStatus } from '../enums/receivable-status.enum';

export class Forecast {
	totalToReceive: number;
	estimatedPaymentDate: string;
	status: ReceivableStatus;

	isNextPayment: boolean;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, ReceivableStatus);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/receivables/models/forecast.model.ts